export default __webpack_public_path__ + "static/storyplate-27ddefb4f62269eba9b4ca34630e22d2.jpg";